package com.flowyride.core.map

import com.flowyride.core.domain.model.GeoPoint

/** A saved address drawn on the map (its emoji or colored dot); [id] comes back when it is tapped. */
data class MapPlace(val id: Long, val point: GeoPoint, val emoji: String?, val color: Int?)

/** A speed camera drawn on the map; [id] comes back when it is tapped. */
data class MapSpeedCamera(val id: String, val point: GeoPoint)

/** Asks the map to centre on [point]; a new [id] repeats the request for the same point. */
data class CenterRequest(val point: GeoPoint, val id: Int)
